import { ReactText } from 'react';
import { getStore } from 'base/store';
import { IVariant } from 'base/interfaces/product';
import { ILocaleList } from 'mod/store/locale/interface';
import { IPoolsVariant } from 'base/interfaces/diyPools';

export type ParsedPriceType = {
    currencySymbol: string;
    currency: string;
    integer: string;//整数
    decimal: string;//小数
    decimalSeparator: string; //小数分隔符
    thousandsSeparator: string; //千分位分隔符
};

export type FormatedPriceType = {
    currencySymbol: string;
    currency: string;//Currency Code
    integer: string;//整数
    decimal: string;//小数
};

const currencyConfig = {
    USD: {
        precision: 2,
        decimalSeparator: '.',
        thousandsSeparator: ',',
    }
};

export type IFinalPrice = {
    price: number;
    priceDisplay: string;
    lineThroughPrice?: number;
    lineThroughPriceDisplay?: string;
}

// 价格解析成对象
export const parsePrice = (price: ReactText): ParsedPriceType => {
    const { rootStore, persistStore } = getStore();
    const localeList = persistStore?.state?.localeList;
    const country = rootStore?.state?.country;
    const currency = rootStore?.state?.currency;
    const countryItem = localeList!.find(item => item.countryCode === country);
    const _targetCurrency = countryItem!.currencyList.find(item => item.code === currency);
    const currencySymbol = (_targetCurrency?.currencySymbol) || '';

    // @ts-ignore
    const config = currencyConfig[currency] || currencyConfig['USD'];
    const { precision } = config;

    // 四舍五入及小数点位数
    const multiples = Number(`1${new Array(precision).fill(0).join('')}`);
    const roundPrice = String((Math.round(Number(price) * multiples) / multiples).toFixed(precision));

    const arr = roundPrice.split('.');
    return {
        integer: arr[0],
        decimal: arr[1] || '',
        currencySymbol,
        currency,
        ...config
    }
};

// 整数添加千分位分隔符，小数添加小数点
export const formatPrice = (price: ReactText): FormatedPriceType => {
    const parsed = parsePrice(price);
    return {
        currencySymbol: parsed.currencySymbol,
        currency: parsed.currency,
        integer: parsed.integer.replace(/(\d)(?=(\d{3})+$)/g, `$1${parsed.thousandsSeparator}`),
        decimal: parsed.decimal ? `${parsed.decimalSeparator}${parsed.decimal}` : '',
    }
};

/**
 * 最终的展示价格 （有deal价格展示deal价格(afterPerDiscountPriceScale)，没有deal取shopPrice的）
 * @param variant sku信息
 * @return {
 *      price: number;
 *      priceSymbol: string;
 *  }
 */
export const finalPrice = (variant?: IVariant | IPoolsVariant): IFinalPrice => {
    if (!variant) {
        return {
            price: 0,
            priceDisplay: '',
        }
    }

    const {
        shopPriceExchange,
        shopPriceExchangeDisplay,
        dealPriceExchange,
        dealPriceExchangeDisplay
    } = variant

    if (dealPriceExchangeDisplay) {
        return {
            price: dealPriceExchange || 0,
            priceDisplay: dealPriceExchangeDisplay,
            lineThroughPrice: shopPriceExchange,
            lineThroughPriceDisplay: shopPriceExchangeDisplay
        }
    }

    return {
        price: shopPriceExchange || 0,
        priceDisplay: shopPriceExchangeDisplay || '',
    }
}